import React from 'react';
import { applyComponentTheme } from '../../theme';
import SolidBackground from '../SolidBackground';
import ChevronBackground from './ChevronBackground';
import { NoBackground } from './styles';

export enum BackgroundType {
  CHEVRON = 'CHEVRON',
  REVERSE_CHEVRON = 'REVERSE_CHEVRON',
  SOLID = 'SOLID',
  NONE = 'NONE',
}

type BackgroundProps = {
  backgroundType: BackgroundType | undefined;
  styledBackground?: boolean;
  children?: React.ReactNode;
};

const Background: React.FC<BackgroundProps> = ({
  backgroundType,
  styledBackground,
  children,
}) => {
  switch (backgroundType) {
    case BackgroundType.CHEVRON:
      return <ChevronBackground>{children}</ChevronBackground>;
    case BackgroundType.REVERSE_CHEVRON:
      return <ChevronBackground reverse>{children}</ChevronBackground>;
    case BackgroundType.SOLID:
      return <SolidBackground>{children}</SolidBackground>;
    case BackgroundType.NONE:
      return <NoBackground>{children}</NoBackground>;
    default:
      if (styledBackground) {
        return <ChevronBackground>{children}</ChevronBackground>;
      }
      return <NoBackground>{children}</NoBackground>;
  }
};

export default applyComponentTheme(Background, 'Background');
